export default __webpack_public_path__ + "d24cf03e47052114ac632716f4468657.otf";